import AnaliticaBox from "../analiticaBox";
import Pills from "../../pills";

import styles from "./styles.module.scss";

const Analitica = (props) => {
  return (
    <Pills
      id="analitica-explorer-pills"
      className={styles.container}
      tabsClassName={styles.pills}
      enableReinitialize={false}
      tabs={[
        {
          id: "analitica-conversions",
          tab: { title: "Conversions" },
          pane: (
            <AnaliticaBox
              forceSearch={true}
              forceRecommended={true}
              mode="conversions"
              {...props}
              key="analitica-box-conversions"
            />
          )
        },
        {
          id: "analitica-metrics",
          tab: { title: "Metrics" },
          pane: (
            <AnaliticaBox
              {...props}
              mode="metrics"
              key="analitica-box-metrics"
            />
          )
        }
      ]}
    />
  );
};

export default Analitica;
